import { useContext } from "react";
import { PageContext, PAGE_FAQ, PAGE_LOGIN, PAGE_REGISTER } from "../contexts/PageContext";
import PageFaq from "../subpages/PageFaq";
import PageRegister from "../subpages/PageRegister";
import PageSignin from "../subpages/PageSignin";

const PageLogin = () => {

    const { page } = useContext(PageContext)

    return (
        <div style={{marginTop : '-30px'}}>
            <div className="d-md-none"><br /></div>
            <div className="container-fluid" style={{maxWidth : '992px'}} hidden={page !== PAGE_LOGIN}>
                <PageSignin />
            </div>
            <div className="container-fluid" style={{maxWidth : '576px'}} hidden={page !== PAGE_REGISTER}>
                <PageRegister />
            </div>
            <div className="container-fluid" style={{maxWidth : '768px'}} hidden={page !== PAGE_FAQ}>
                <PageFaq />
            </div>
        </div>
    )
}

export default PageLogin;